/**
 * Education levels that make a provider a psychiatry provider rather than a therapist.
 * Referenced by the landing page header, QuickCheckout, and One-Page Checkout so all three
 * arms label a provider's type the same way per magic-strings rule.
 */
export const PSYCHIATRIST_EDUCATION_LEVELS = ['MD', 'DO', 'RN'];
